import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { createUpdateTemplates } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function saveTemplates({
  params,
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(createUpdateTemplates(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  params: { Name: string; Content: string; ContainerName: string };
  accountId: number;
};

type TSnapshot = unknown;

function useSaveTemplate(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ params, accountId }: TVariables) => {
    const postResult = await saveTemplates({
      params,
      accountId,
    });
    if (postResult.Data) {
      queryClient.invalidateQueries(['get_procedure'], {
        refetchInactive: true,
      });
      if (params.ContainerName === 'layouts') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'layouts'],
          {
            refetchInactive: true,
          },
        );
      } else if (params.ContainerName === 'tables') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'tables'],
          {
            refetchInactive: true,
          },
        );
      }
    } else if (postResult.Errors[0]) throw postResult;
    return postResult;
  });
}

export { useSaveTemplate };
